import { Button, Input } from 'components/atoms';
import ComplexInputWrapper from 'components/atoms/inputs/wrapper/complex/ComplexInputWrapper';
import { FormInput } from 'components/molecules';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiArrowRight, PiBuildings, PiUser } from 'react-icons/pi';
import { CUSTOMER_TYPE, ILabelForm } from 'services/labels/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getCountriesPhoneNumberPrefixOptionValues } from 'utils/global/countries.utils';

const LabelContactStep = () => {
  const { t } = useTranslation();
  const formik = useFormikContext<ILabelForm>();
  
  return (
    <LabelFormStep
      header={t('label.form.contact.header')}
      description={t('label.form.contact.description')}>
        <div className='flex gap-4 w-full'>
        <Button
          fullWidth
          variant={formik.values.customerType === CUSTOMER_TYPE.Physical ?  BUTTON_VARIANT.submit : BUTTON_VARIANT.default}
          onClick={() =>
            formik.setFieldValue('customerType', CUSTOMER_TYPE.Physical)
          }>
          <Button.Icon icon={<PiUser />} />

          <Button.Text
            text={t(
              `enum.CUSTOMER_TYPE.${CUSTOMER_TYPE[CUSTOMER_TYPE.Physical]}`
            )}
          />
        </Button>
        <Button
          fullWidth
          variant={formik.values.customerType === CUSTOMER_TYPE.Company ? BUTTON_VARIANT.submit : BUTTON_VARIANT.default}
          onClick={() =>
            formik.setFieldValue('customerType', CUSTOMER_TYPE.Company)
          }>
          <Button.Icon icon={<PiBuildings />} />
          <Button.Text
            text={t(
              `enum.CUSTOMER_TYPE.${CUSTOMER_TYPE[CUSTOMER_TYPE.Company]}`
            )}
          />
        </Button>
      </div>
      <ComplexInputWrapper>
        <FormInput.Text
          name='firstName'
          label={t('input.label.firstName')}
        />
        <FormInput.Text
          name='lastName'
          label={t('input.label.lastName')}
        />
      </ComplexInputWrapper>
      <FormInput.Text
        wrapperClassName='max-w-full'
        name='email'
        label={t('input.label.email')}
      />
      <Input.ComplexWrapper sizes={[30, 70]}>
        <FormInput.Select
          name='phoneNumberPrefix'
          label={t('input.label.phoneNumberCodeShort')}
          placeholder=''
          isCreatable
          options={getCountriesPhoneNumberPrefixOptionValues()}
        />
        <FormInput.Text
          name='phoneNumber'
          label={t('input.label.phoneNumber')}
        />
      </Input.ComplexWrapper>
      {formik.values.customerType === CUSTOMER_TYPE.Physical && (
        <FormInput.Text
          max={new Date().toISOString().split('T')[0]}
          min={'1900-01-01'}
          onChange={e => {
            const targetValue = e.target.value;
            formik.setFieldValue('dateOfBirth', targetValue);
          }}
          label={t('input.label.dateOfBirth')}
          type='date'
          name='dateOfBirth'
          wrapperClassName='max-w-full'
        />
      )}
    </LabelFormStep>
  );
};

export default LabelContactStep;
